module.exports = __webpack_public_path__ + "static/media/thumb.d4c924d5.jpg";